import qs from 'qs'

import request from 'checkout/utils/axios'

const BASE_HOST_URI = window.env && window.env.baseHost
const ASSOCIATED_ENDPOINT = `${BASE_HOST_URI}/carrinho/crosses`
const CART_ENDPOINT = `${BASE_HOST_URI}/api/v1/cart`
const ASSOCIATED_ORIGIN = 'minicart'
const CROSS_SERVICE_ENDPOINT = `${BASE_HOST_URI}/api/v3/crosses/services`
const SHIPPING_ENDPOINT = `${BASE_HOST_URI}/api/v1/shipments`
const CART_SERVICES = `${BASE_HOST_URI}/api/v3/carts/services`

export const getCrossServicesList = async payload => {
  const response = await request
    .get(CROSS_SERVICE_ENDPOINT + payload.qs)

  return response
}

export const getServiceList = async (regionId, products) => {
  const params = qs.stringify(
    {
      regionId,
      products
    },
    {
      addQueryPrefix: true,
      arrayFormat: 'indices',
      encode: false,
      skipNulls: true
    }
  )

  const response = await request
    .get(CROSS_SERVICE_ENDPOINT + params)

  return response
}

export const getServiceListMiniCart = async (params) => {
  const response = await request
    .get(CROSS_SERVICE_ENDPOINT + params)

  return response
}

export const getAssociateds = async () => {
  const response = await request
    .get(ASSOCIATED_ENDPOINT)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const putAssociatedProductsInCart = async params => {
  const response = await request
    .post(CART_ENDPOINT, { ...params, origin: ASSOCIATED_ORIGIN })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const putProductsInCart = async params => {
  const response = await request
    .post(CART_ENDPOINT, { ...params })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const fetchCartShipping = async (postalCode = '') =>
  (await request.get(`${SHIPPING_ENDPOINT}/${postalCode}`)).data

export const putServicesInCart = async params => {
  const response = await request
    .post(CART_SERVICES, { ...params })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const removeServiceFromCart = productId =>
  request
    .delete(`${CART_SERVICES}/${productId}`)
    .then(({ data, status }) => ({ data, status }))
    .catch(err => {
      throw err.response
    })
